import { createSlice } from '@reduxjs/toolkit';

// Retrieve from localStorage on initial load
const persistedSocietyId = localStorage.getItem('societyId');

const initialState = {
    bankAccountList: [],
    buildingData: [], // Fixed typo here
    status: 'idle',
    userId: localStorage.getItem("userId") || null,
    societyId: persistedSocietyId || '',
    setIsListEmpty: true,
    wingData: [], // Fixed typo here
    unitData: [],
    memberData: [],
    commiteeData: [],
    commiteeMemberData: [],
    memberShareData: [],
    shareTransferRegisterData: [],
    parkingMasterData: [],
    masterParkingData: [],
    nomineeData: [],
    tenantsData: [],
    vendorMasterData: [],
    bankTransferData: [],
    vendorMasterBankData: [],
    societyAssetsData: [],
    societyUtilitiesData: [],
    memberUtilitiesData: [],
    societyAdminData: [],
    chartOfAccountsList: [],
    chartOfAccountItemsList: [],
    chartOfAccountSubItemsList: [],
    chargeTypeList: [],
    budgetList: [],
    voucherList: [],
    rateCardList: [],
    invoiceList: [],
    receiptList: [],
    billingRequestList: [],
    visitorConfigList: [],
    subscriptionListData: true
};

const buildingSlice = createSlice({
    name: 'buildingList',
    initialState,
    reducers: {
        setSocietyId(state, action) {
            state.societyId = action.payload;
            localStorage.setItem('societyId', action.payload);
        },
        setBankAccountList(state, action) {
            state.bankAccountList = action.payload;
        },
        getVisitorConfigList: (state, action) => {
            state.visitorConfigList = action.payload;
        },
        getBillingRequestList: (state, action) => {
            state.billingRequestList = action.payload;
        },
        setUserId: (state, action) => {
            state.userId = action.payload;
             localStorage.setItem('userId', action.payload);
        },
        setIsBankListEmpty(state, action) {
            state.isBankListEmpty = action.payload;
        },
        getBuildingList(state, action) {
            state.buildingData = action.payload;
        },
        getChartOfAccountsList(state, action) {
            state.chartOfAccountsList = action.payload;
        },
        getChartOfAccountItemsList(state, action) {
            state.chartOfAccountItemsList = action.payload;
        },
        getChartOfAccountSubItemsList(state, action) {
            state.chartOfAccountSubItemsList = action.payload;
        },
        getChargeTypesList(state, action) {
            state.chargeTypeList = action.payload;
        },
        getBudgetsList(state, action) {
            state.budgetList = action.payload;
        },
        getPettyCashVouchersList(state, action) {
            state.voucherList = action.payload;
        },
        getRateCardsList(state, action) {
            state.rateCardList = action.payload;
        },
        getInvoiceMasterList: (state, action) => {
            state.invoiceList = action.payload;
        },
        getReceiptMasterList: (state, action) => {
            state.receiptList = action.payload;
        },
        getSocietyId(state, action) {
            state.societyId = action.payload;
            // Save to localStorage
            localStorage.setItem('societyId', action.payload);
        },
        getIsListEmpty(state, action) {
            state.setIsListEmpty = action.payload;
        },
        getWingList(state, action) {
            state.wingData = action.payload;
        },
        getUnitList(state, action) {
            state.unitData = action.payload;
        },
        getMemberList(state, action) {
            state.memberData = action.payload;
        },
        getCommiteeList(state, action) {
            state.commiteeData = action.payload;
        },
        getCommiteeMemberList(state, action) {
            state.commiteeMemberData = action.payload;
        },
        getmemberShareList(state, action) {
            state.memberShareData = action.payload;
        },
        getShareTransferRegisterList(state, action) {
            state.shareTransferRegisterData = action.payload;
        },
        getParkingMasterList(state, action) {
            state.parkingMasterData = action.payload;
        },
        getMasterParkingList(state, action) {
            state.masterParkingData = action.payload;
        },
        getNomineeList(state, action) {
            state.nomineeData = action.payload;
        },
        getTenantsList(state, action) {
            state.tenantsData = action.payload;
        },
        getVendorMasterList(state, action) {
            state.vendorMasterData = action.payload;
        },
        getBankTransferList(state, action) {
            state.bankTransferData = action.payload;
        },
        getVendorMasterBankList(state, action) {
            state.vendorMasterBankData = action.payload;
        },
        getSocietyAssetsList(state, action) {
            state.societyAssetsData = action.payload;
        },
        getSocietyUtilitiesList(state, action) {
            state.societyUtilitiesData = action.payload;
        },
        getMemberUtilitiesList(state, action) {
            state.memberUtilitiesData = action.payload;
        },
        getSocietyAdminList(state, action) {
            state.societyAdminData = action.payload;
        },
        getSubscriptionListData(state, action) {
            state.subscriptionListData = action.payload;
        },
    },
});

export const { setSocietyId, getBuildingList, getSocietyId, getIsListEmpty, getWingList, getUnitList,setUserId,
    getMemberList, getCommiteeList, getCommiteeMemberList, getmemberShareList, getShareTransferRegisterList, getParkingMasterList,
    getMasterParkingList, getNomineeList, getTenantsList, getVendorMasterList, getSocietyAssetsList,getReceiptMasterList,getPettyCashVouchersList,getBankTransferList,
    getMemberUtilitiesList, getInvoiceMasterList, getSocietyUtilitiesList, getSubscriptionListData, getSocietyAdminList, setBankAccountList,getChartOfAccountItemsList,
    getChartOfAccountSubItemsList,getBillingRequestList,
    setIsBankListEmpty, getVendorMasterBankList, getChartOfAccountsList, getChargeTypesList, getVisitorConfigList,getRateCardsList,getBudgetsList,
} = buildingSlice.actions;

export default buildingSlice.reducer;